import { ServiceLockResults } from './service-lock-results';

export class ServiceMoveRecord {
    public LockResults?: ServiceLockResults;
    public NewPath?: string;
    public ROSequence?: any;
    public UpdatedRecords?: Array<any>;
}
